export class StatusIconMapElement {
    public constructor(
        public processType: string,
        public messageState: string,
        public iconName: string,
        public filterName: string) { }
}
